module.exports = __webpack_public_path__ + "media/images/book-d284d4e0bc06f2257375e80dbf6d0811.png";